<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" style="padding:5%;margin:5%;border-style:double;"> <h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Getting the Most Out of  <i> Knowing God Bible Study</i></a></div>
<div class="SOM_pre"><span href="#/pre3" title="Link target outside of Sample"><span class="mev3">INTRODUCTION</span><br/>
      Looking for God</span></div>
<div class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample"><span class="mev3">SESSION ONE</span><br/>
      God Beyond Comparison<br/>
<i>Isaiah 40:21-31</i></span></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev3">SESSION TWO</span><br/>
      God’s Unfailing Faithfulness<br/>
<i>Psalm 107:1-32</i></span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev3">SESSION THREE</span><br/>
      God: Father, Son, Spirit<br/>
<i>John 14:1-11; 16:5-15</i></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev3">SESSION FOUR</span><br/>
      God’s Merciful Discipline<br/><i>Hebrews 12:1-13</i></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev3">SESSION FIVE</span><br/>
      God’s Ultimate Triumph<br/>
<i>Romans 8:31-39</i></span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample"><span class="mev3">LEADING A SMALL GROUP</span></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample"><span class="mev3">SUGGESTED RESOURCES</span></span></div> <div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample"><span class="mev3">THE IVP SIGNATURE COLLECTION</span></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample"><span class="mev3">ALSO AVAILABLE FROM IVP</span></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample"><span class="mev3">ABOUT THE AUTHOR</span></span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample"><span class="mev3">MORE TITLES FROM INTERVARSITY PRESS</span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?07d67f13